import React, { Component } from "react";
import "./AddUser.css";
import {
  Card,
  Row,
  Col,
  Spin,
  Button,
  Select,
  Input,
  Table,
  Radio,
  DatePicker,
  notification,
  Drawer,
  AutoComplete,
} from "antd";
import { Form } from "@ant-design/compatible";
import Config from "../../config";
import ListTaxNpi from "./ListNpiTax";
import BlankNpi from "../images/BlankNpi.svg";
import InvalidTax from "../images/InvalidTax.svg";
import AddNpiGroup from "./AddNpiGroup";
import { updateUserList } from "../../store/broadcaster/BroadcastRegister";
import { CloseCircleFilled } from "@ant-design/icons";
import GroupAdmin from "./GroupAdmin";
import ProviderTaxid from "./ProviderTaxid";
import AddIPAs2 from "./AddIPAs2";
import InputBox from "../CommonComponent/InputBox/Index";

class AddUser extends Component {
  constructor(props) {
    super(props);
    this.state = {
      EditClickForIPAs: false,
      componentKey: 1,
      isLoading: false,
      addTax: false,
      addNpi: false,
      combinations: [],
      combinations1: [],
      selIPAs: [],
      taxIDandNPIDetailsByIPA: [],
      SelectValue: "",
      Geticon: false,
      clicked: false,
      Taxclicked: false,
      Npiclicked: false,
      ProviderNPIs: [],
      TaxID: [],
      AddRole: [],
      message: "",
      disabledaccordingtoinput: true,
      disabledaccordingtoinputTax: true,
      disabledNPI: false,
      disabled: false,
      inputvalue: "",
      disableRole: "",
      UserType: "",
      RoleWithOptions: "",
      RoleWiththreeOption: "",
      RoleWithFourOption: "",
      deleteTaxNpiMapping: [],
      addedNpi: "",
      addedTaxId: "",
      accessDeniedForTaxId: false,
      accessDeniedForNpi: false,
      EligibilityOnly: "no",
      SelectedNPIList: [],
      filteredNpis: [],
      searchInput: "",
      selTaxId: null,
      selTaxNPIs: [],
      IsDSNP:1,
    };
  }

  handleChangeNPI = (e) => {
    let regex = new RegExp(/^[0-9]*$/);
    this.setState({ accessDeniedForNpi: false });
    if (e.target.value.length == 10 && regex.test(e.target.value)) {
      this.setState({
        disabledaccordingtoinput: false,
        Npiclicked: true,
        addedNpi: e.target.value,
      });
    } else if (e.target.value.length === 0) {
      this.setState({
        disabledaccordingtoinput: false,
        Npiclicked: true,
      });
    } else {
      this.setState({
        disabledaccordingtoinput: true,
        Npiclicked: true,
      });
    }
  };

  setProviderCombinations = (items)=>{
    console.log("items-2",items)
    this.setState({
      ProviderNPIs: items && items.length > 0 ? items[0].npis : [],
      TaxID: items && items.length > 0 ? items[0].taxId : "", 
    });
  }

  setCombinations = (items) => {
    console.log("items-1",items)
    this.setState({
      combinations: items && items.length > 0 ? items : [],
    });
  };
  setCombinations1 = (items) => {
    // console.log("iiinnn22", items)
    this.setState({
      combinations1: items && items.length > 0 ? items : [],
    });
  };
  setTaxIDandNPIDetailsByIPA = (items) => {
    console.log("new prop data: ", items);
    this.setState({
      taxIDandNPIDetailsByIPA:
        items && items.Details.length > 0 ? items.Details : [],
    });
    console.log("catch", this.state.taxIDandNPIDetailsByIPA);
  };
  SeteditClickForIPAs = (item) => {
    console.log("Clickk",item)
    this.setState({
      EditClickForIPAs: item
    })
  }
  SetupdateClickForIPAs = (item) => {
    console.log("Clickk",item)
    this.setState({
      UpdateClickForIPAs: item
    })
  }

  handleChangeTax = (e) => {
    let regex = new RegExp(/^[0-9]*$/);
    this.setState({ accessDeniedForTaxId: false });
    if (e.target.value.length == 9 && regex.test(e.target.value)) {
      this.setState({
        disabledaccordingtoinputTax: false,
        Taxclicked: true,
        addedTaxId: e.target.value,
      });
    } else if (e.target.value.length === 0) {
      this.setState({
        disabledaccordingtoinputTax: false,
        Taxclicked: true,
      });
    } else {
      this.setState({
        disabledaccordingtoinputTax: true,
        Taxclicked: true,
      });
    }
  };

  handleSubmit = async () => {
    // e.preventDefault();
    let TenantID = sessionStorage.getItem("Tanent");
    TenantID = parseInt(TenantID, 10);
    // this.props.form.validateFields().then(async (values, err) => {
      
    this.props.form.validateFields(async (err, values) => {
      if (!err) {
        this.setState({
          isLoading: true,
        });
        if (values.MiddleName === "") {
          values.Name = values.FirstName + " " + values.LastName;
        } else {
          values.Name =
            values.FirstName + " " + values.MiddleName + " " + values.LastName;
        }
        values.NPI = [];
        values.Tax = [];
        if (this.state.SelectValue === "Provider") {
          console.log(this.state.ProviderNPIs)
          values.NPI = this.state.ProviderNPIs.map(item => ({
            NPINumber: item.npi != null ? String(item.npi) : ""
          }));
           values.Tax =  [{ TaxNumber: this.state.TaxID }]
          // this.state.TaxID.map((item) => {
          //   return { TaxNumber: item };
          // });
        }

        // values.RoleName = this.state.AddRole.map((item) => {
        //   return { Name: item };
        // });
        values.RoleName = [];
        if (this.state.UserType === 1)
          values.RoleName.push({ Name: "User Admin" });
        if (this.state.SelectValue && this.state.SelectValue != "Not Required")
          values.RoleName.push({ Name: this.state.SelectValue });
        let mapping = [];
        let mapping2 = [];
        if (
          this.state.SelectValue === "Group User"
        ) {
          let taxCombination = this.state.combinations.filter(
            (item) => item.taxId != "None"
          );
          if (taxCombination && taxCombination.length > 0) {
            for (let item of taxCombination) {
              let _npis = [];
              if (!item.delete && !item.save) {
                //when item (taxID) is new
                mapping.push({ TaxID: item.taxId, NPIList: _npis });
                for (let npi of item.npis) {
                  if (!npi.delete && !npi.save)
                    _npis.push({ NPINumber: npi.npi });
                  // if (!npi.delete && !npi.save && npi.GroupNPI)
                  //   _npis.push({ NPINumber: npi.GroupNPI });
                }
              }
            }
          }
          let npiCombination = this.state.combinations.filter(
            (item) => item.taxId === "None"
          )[0];
          if (npiCombination) {
            values.NPI = npiCombination.npis.map((item) => {
              return { NPINumber: item.npi };
            });
          }
        }
        if (this.state.SelectValue === "IPA User") {
          console.log("combinations}}", this.state.combinations1);
          console.log(
            "taxIDandNPIDetailsByIPA::",
            this.state.taxIDandNPIDetailsByIPA
          );
          let IPAsCombination = this.state.combinations1.filter(
            (item) => item.IPA != "None"
          );
          console.log("IPAsCombinatio:", IPAsCombination);
          
          if (IPAsCombination && IPAsCombination.length > 0) {
            console.log(
              "this.state.taxIDandNPIDetailsByIPA: ",
              this.state.taxIDandNPIDetailsByIPA
            );
            const datanew = this.state.taxIDandNPIDetailsByIPA;
            //  const data = this.state.TaxIDList.map(({ GroupTaxId }) => ({ GroupTaxId }))
            console.log("asa ", datanew);
            const transformedData = datanew.reduce((result, obj) => {
              const existingItem = result.find(
                (item) => item.TaxID === obj.groupTaxId
              );

              if (existingItem) {
                existingItem.NPIList.push({ NPINumber: obj.npiNumber });
              } else {
                result.push({
                  TaxID: obj.groupTaxId,
                  NPIList: [
                    // { NPINumber: obj.groupNPI },
                    { NPINumber: obj.npiNumber.toString() }
                  ].filter(obj => obj.NPINumber !== null),
                });
              }

              return result;
            }, []);
            mapping = transformedData;
            let _taxid = [];
            // for (let item of IPAsCombination) {
            //   mapping2.push({ IPA: item.IPA, TaxIDList: _taxid }); // TaxIDList: _taxid
            //   this.state.taxIDandNPIDetailsByIPA.forEach((obj) => {
            //     _taxid.push({ TaxNumber: obj.GroupTaxId });
            //   });
            // }
            const transformed = this.state.taxIDandNPIDetailsByIPA.reduce((result, item) => {
              const existingIPAIndex = result.findIndex(obj => obj.IPA === item.ipa);
            
              if (existingIPAIndex !== -1) {
                result[existingIPAIndex].TaxIDList.push({ TaxNumber: item.groupTaxId });
              } else {
                result.push({
                  IPA: item.ipa,
                  TaxIDList: [{ TaxNumber: item.groupTaxId }]
                });
              }
            
              return result;
            }, []);
            mapping2 = transformed

           // console.log("_taxid: ", _taxid);
          }
        }

        values.TaxNpiMapping = mapping;
        values.IPATaxIDMapping = mapping2;
        values.TenantID = TenantID;
        values.IsDSNP= this.state.IsDSNP;
        values.EligibilityOnlyFlag = this.state.EligibilityOnly === "yes";
        values.ApprovedBy = sessionStorage.getItem("userEmail");
        console.log(JSON.stringify(values));
        let data = await fetch(Config.api + "/RegisterUser", {
          method: "POST",
          headers: {
            Authorization: sessionStorage.getItem("access_token"),
            Accept: "application/json",
            "Content-type": "application/json",
          },
          body: JSON.stringify(values),
        });
        data = await data.json();
        this.setState({
          isLoading: false,
        });

        if (data.Message === "User Registered Successfully" || data.Message === "User registered successfully with only unique combinations of TINs and NPIs") {
          updateUserList.next("update");
          this.openNotification(data);
          this.props.form.resetFields();
          this.setState({
            ProviderNPIs: [],
            TaxID: [],
            // AddRole: [],
          });
          this.props.getType("List");
        } else {
          this.openNotification(data);
        }
      }
      // this.props.form.resetFields();
    });
  };
  openNotification = (res) => {
    notification.open({
      description:
        res.Message === "" ? "Email ID already Exist !" : res.Message,
      // onClick: () => {
      // },
    });
  };

  setDeletedProviderCombinations = (item) => {
    console.log("setDeletedProviderCombinations",item)
    this.setState({
      deleteTaxNpiMapping: item
        ? [...this.state.deleteTaxNpiMapping, item]
        : [...this.state.deleteTaxNpiMapping],
    });
  };

  setDeletedCombinations = (item) => {
    this.setState({
      deleteTaxNpiMapping: item
        ? [...this.state.deleteTaxNpiMapping, item]
        : [...this.state.deleteTaxNpiMapping],
    });
  };
  handleChange = (value) => {
    if (value != null) {
      var today = new Date();
      var todaysmonth = String(today.getMonth() + 1).padStart(2, "0");
      var agemonth = value.format("MM/DD/YYYY").split("/")[0];
      var thisYear = 0;
      if (todaysmonth < agemonth) {
        thisYear = 1;
      } else if (todaysmonth == agemonth && todaysmonth < agemonth) {
        thisYear = 1;
      }
      var age =
        today.getFullYear() -
        value.format("MM/DD/YYYY").split("/")[2] -
        thisYear;
      this.setState({
        CurrentAge: age,
      });
    }
  };

  validateTaxAndNpi = (type, value) => {
    if (sessionStorage.getItem("ProviderRole") === "PROVIDER") {
      let npi = sessionStorage.getItem("npivalue");
      let taxId = sessionStorage.getItem("taxid");
      if (type === "npi" && npi.includes(value)) return true;
      if (type === "taxId" && taxId.includes(value)) return true;
      else return false;
    } else return true;
  };

  addItem(e) {
    this.setState({
      // addNpi: true
    });
    e.preventDefault();
    const { ProviderNPIs } = this.state;
    const newItem = this.state.addedNpi;
    // const isONTheList = ProviderNPIs.includes(this.state.addedNpi);

    if (!this.validateTaxAndNpi("npi", this.state.addedNpi)) {
      this.setState({
        accessDeniedForNpi: true,
        addNpi: false,
      });
      return;
    } else {
      if (newItem) {
        this.setState({
          ProviderNPIs: [newItem],
          addNpi: true,
        });
      } else {
        this.setState({
          disabledNPI: true,
        });
      }
      this.setState({ accessDeniedForNpi: false });
    }
    // this.addForm1.reset();
  }

  addItemTax(e) {
    this.setState({
      // addTax: true
    });
    e.preventDefault();
    const { TaxID } = this.state;
    const newItemTax = this.state.addedTaxId;
    // const isONTheListTax = TaxID.includes(this.state.addedTaxId);

    if (!this.validateTaxAndNpi("taxId", this.state.addedTaxId)) {
      this.setState({
        addTax: false,
        accessDeniedForTaxId: true,
      });
      return;
    } else {
      if (newItemTax) {
        this.setState({
          TaxID: [newItemTax],
          addTax: true,
        });
      } else {
        this.setState({
          disabled: true,
        });
      }
      this.setState({ accessDeniedForTaxId: false });
    }
    // this.addForm.reset();
  }

  removeItem = async (item) => {
   
    console.log(item)
    this.setState({
      disabledaccordingtoinput: true,
      Npiclicked: false,
    });
    const newProviderNPIs = this.state.ProviderNPIs.filter((ProviderNPIs) => {
      return ProviderNPIs !== item;
    });
    await this.setState({
      ProviderNPIs: [...newProviderNPIs],
      disabledNPI: false,
      addNpi: false,
    });
  };

  removeItemTax = async (item) => {
    this.setState({
      disabledaccordingtoinputTax: true,
      Taxclicked: false,
    });
    const newTaxID = this.state.TaxID.filter((TaxID) => {
      return TaxID !== item;
    });
    await this.setState({
      TaxID: [...newTaxID],
      disabled: false,
      addTax: false,
    });
  };

  validateUser = () => {
    // Existing Plan Admin validation
    if (
      !this.state.UserType &&
      sessionStorage.getItem("PlanAdminRole") === "Plan Admin"
    ) {
      return false;
    }
  
    // Plan Admin
    if (
      this.state.UserType &&
      this.state.SelectValue === "Plan Admin" &&
      this.state.EligibilityOnly
    ) {
      return true;
    }
  
    // Group User
    if (
      this.state.SelectValue === "Group User" &&
      this.state.combinations &&
      this.state.combinations.length > 0
    ) {
      return true;
    }
  
    // IPA User
    if (
      this.state.SelectValue === "IPA User" &&
      this.state.combinations1 &&
      this.state.combinations1.length > 0
    ) {
      return true;
    }

    // Provider
    if (
      this.state.SelectValue === "Provider" &&
      this.state.ProviderNPIs &&
      this.state.ProviderNPIs.length > 0 &&
      this.state.TaxID &&
      this.state.TaxID.length > 0
    ) {
      return true;
    }
  
    return false;
  };

  handleReset = () => {
    this.props.getType("List");
    this.setState({
      SelectValue: "",
      CurrentAge: "",
      AddRole: [],
      Geticon: false,
      clicked: false,
    });
  };
  getValue = () => {
    this.setState({
      Geticon: true,
    });
  };

  onChange = (e, type) => {
    console.log("ee",e.target.value,"type",type)
    this.setState({
      UserType: type === "admin" ? e.target.value : this.state.UserType,
      EligibilityOnly:
        type === "e&b" ? e.target.value : this.state.EligibilityOnly,
        IsDSNP: type === "isDsnp" ? e.target.value : this.state.IsDSNP,
    });
  };

  ChangeWithOptions = (e) => {
    const selectedRole = e.target.value;
    this.setState({
      RoleWithOptions: selectedRole,
      SelectValue: selectedRole,
  
      // Reset DSNP whenever role changes
      IsDSNP: 1,
  
      ProviderNPIs:
        selectedRole === "Provider"
          ? []
          : this.state.ProviderNPIs,
  
      combinations:
        selectedRole === "Provider" || selectedRole === "Group User"
          ? []
          : this.state.combinations,
    });
  };

  checkUserRole = (role) => {
    
    let userRoles = sessionStorage.getItem("rolename");
    return userRoles.includes(role);
  };

  OpenDrawer = async (value) => {
     console.log(value)
    await this.setState({
      showDrawer: !this.state.showDrawer,
      NPIstate: value == "TaxId" ? "TaxId" : "Npi",
      SelectedNPIList: [],
      selTaxNPIs: [],
      totalTaxNPIs: [],
      npisList: [],
      selTaxId: null,
      type: "new",
      showList: true
    });
  };

  setNpisList = (npis) => {
    this.setState({
      totalTaxNPIs: npis
    })
  }
  onSearch = async (e) => {
    // this.props.form.validateFields(async (err, values) => {
    //   if (!err) {
      console.log("afasdas")
    const headers = {
      Authorization: sessionStorage.getItem("access_token"),
      Accept: "application/json",
      "Content-type": "application/json",
    };
    let npisList = [];
    this.setState({ selTaxId: e })
    // if PA then ok, but if ipa user/ group user then check tax id belongingness
    // if (!this.validateTaxId(e))
    //   return
    // this.setState({
    //   isLoading: true,
    //   npisList: []
    // })

    const promise = await fetch(`${Config.api}/ListNPIBasedOnTaxID?PlanName=${sessionStorage.getItem("planName")}`, {
      method: "POST",
      headers,
      body: JSON.stringify({
        TaxId: [e],
        GroupTaxId: [e],
      })
    })

    let res = await promise.json();
    let npis = []
    let _selTaxNpis = []
    let roles = sessionStorage.getItem("rolename")

    let filteredNpis = roles.includes("Group User") ? res.Details.filter((item) => (this.state.accessNpis.includes(item.groupNPI) || this.state.accessNpis.includes(`${item.providerNPI}`))) : res.Details

    if(Array.isArray(filteredNpis)){

      filteredNpis.map((item) => {
        let name = `${item.firstName ? item.firstName : ""}${item.middleName ? ' ' + item.middleName : ''} ${item.lastName ? item.lastName : ""}`
        if (this.state.selTaxNPIs.findIndex(val => val.npi == item.providerNPI) < 0) {  // new case
          npis.push({ id: item.primaryTaxId, npi: item.providerNPI, groupNPI: item.groupNPI, name, delete: false, save: false })
        }
        else {
          if (this.state.type === "edit") {
            _selTaxNpis.push({ id: item.primaryTaxId, npi: item.providerNPI, groupNPI: item.groupNPI, name, delete: false, save: true }) //edit combination
          }
        }
        npisList.push({ id: item.primaryTaxId, npi: item.providerNPI, groupNPI: item.groupNPI, name, delete: false, save: false }) // not require delete & save
      });

      // let totalUniqueNPIs = []
      npis = npis.filter((value, index, self) =>
        index === self.findIndex((t) => (
          t.npi === value.npi
        ))
      )

      npisList = npisList.filter((value, index, self) =>
        index === self.findIndex((t) => (
          t.npi === value.npi
        ))
      )

      _selTaxNpis = _selTaxNpis.filter((value, index, self) =>
        index === self.findIndex((t) => (
          t.npi === value.npi
        ))
      )
      await this.setState({
        totalTaxNPIs: npis,
        showDrawer: true,
        selTaxId: e,
        selTaxNPIs: this.state.type === "edit" ? _selTaxNpis : this.state.selTaxNPIs,
        isLoading: false,
        npisList: npisList
      })
    }
    else {
      await this.setState({
        isLoading: false,
        npisList: []
      })
    }
    // }
    // })
  };


  onSelect = (item) => {
    const { name, npi } = this.seperateNPiandName(item);
   console.log(this.seperateNPiandName)
   let itemExist = this.state.SelectedNPIList.filter(val => val.npi == item.split("-")[1])[0]
   if (itemExist) {  //only for already save values
     itemExist.delete = false
   }
   else { // newly added
     this.state.SelectedNPIList.push({
       delete: false,
       save: false,
       name: name,
       npi: npi
     })
   }
   this.setState({
     SelectedNPIList: this.state.SelectedNPIList,
     filteredNpis: [],
     searchNpis: false
   });
 };

 DeleteNPI = (item) => {
   if (item.save) {
     item.delete = true
     this.setState({
       SelectedNPIList: this.state.SelectedNPIList,
     });
   }
   else {
     let newNpis = this.state.SelectedNPIList.filter(val => val.npi != item.npi)
     this.setState({
       SelectedNPIList: [...newNpis],
     });
   }
 };

 submitHandler = () => {
   if (this.state.type === "edit") this.updateCombination();
   else this.addCombination();
   this.props.form.resetFields();
 };
 updateCombination = () => {
   if (this.state.NPIstate === "Npi") {
     let index = this.state.combinations.findIndex(item => item.taxId === "None")
     this.state.combinations[index].npis = this.state.SelectedNPIList;
   } else {  //TaxId
    // let index = this.state.combinations.findIndex(item => item.taxId === this.state.selTaxId) // have to update this
     let index = this.state.combinations.findIndex(
       item => item.taxId === this.state.selTaxId && item.delete !== true
     );
     this.state.combinations[index].npis = this.state.selTaxNPIs
   }
   this.setState({
     combinations: this.state.combinations,
     showDrawer: false
   })
   this.props.setCombinations(this.state.combinations)
   this.getParticularComb()
 };

 addCombination = () => {
   if (this.state.NPIstate === "TaxId") {
     this.state.combinations.push({ taxId: this.state.selTaxId, npis: this.state.selTaxNPIs, delete: 0, save: 0 })
   }
   else {
     this.state.combinations.push({ taxId: 'None', npis: this.state.SelectedNPIList, delete: false, save: false })
   }
   this.closeDrawer()
    console.log("this.state.combinations",this.state.combinations)
    console.log("this.state.TaxID",this.state.TaxID)
    this.setState({
      ProviderNPIs:this.state.combinations[0].npis,
      TaxID:[this.state.combinations[0].taxId],
      addTax:true
      //addNpi:true
    })
    console.log(this.state.ProviderNPIs)
    console.log(this.state.addNpi)
   
 };

  handleSearch = (val) => {
    const searchFor = val?.trim();
    if (searchFor) {
      const newResults = this.state.ListOfNPIWithPlan
        .filter(item =>
          item &&
          item.includes(searchFor) &&
          !item.toLowerCase().startsWith("undefined") // Remove undefined
        )
        .filter((value, index, self) => self.indexOf(value) === index); //  Remove duplicates
  
      this.setState({
        filteredNpis: newResults,
        searchNpis: true,
      });
  
    } else {
      this.setState({
        filteredNpis: [],
        searchNpis: true,
      });
    }
  };

  removeTaxNPI = (item, type) => {
    let removedItem = this.state.selTaxNPIs.filter(val => val.npi === item.npi)[0]

    if (removedItem.save) removedItem.delete = true
    let index = this.state.selTaxNPIs.findIndex(val => val.npi === item.npi)

    const newList = this.state.selTaxNPIs.filter((val) => {
      return val.npi !== item.npi;
    });
    this.setState({
      selTaxNPIs: removedItem.save ? this.state.selTaxNPIs : [...newList],
      totalTaxNPIs: [...this.state.totalTaxNPIs, item],
    });
  };

  addTaxNPI = (item, type) => {
    if (type === "All") {
      let allItems = [...this.state.npisList]  //npisList has save false 
      for (let item of this.state.selTaxNPIs) {
        let index = allItems.findIndex(i => i.npi == item.npi)
        allItems[index].save = true  // to maintain save status
      }
      this.setState({
        selTaxNPIs: allItems,
        totalTaxNPIs: [] //as all npis are added
      });
    }
    else {
      //item is individual obj of npi
      // item.save = false // to add this
      item.delete = false // to add thisZZZ

      let itemExist = this.state.selTaxNPIs.filter(val => val.npi == item.npi)[0]
      if (itemExist) {
        // itemExist.save = false
        itemExist.delete = false
      }
      const newList = this.state.totalTaxNPIs.filter((val) => {
        return val.npi !== item.npi;
      });
      this.setState({
        totalTaxNPIs: newList,
        selTaxNPIs: itemExist ? [...this.state.selTaxNPIs] : [...this.state.selTaxNPIs, item]
      });
    }

  };

  // validateTaxId = (taxId) => {
  //   const taxIDMappingRaw = sessionStorage.getItem("taxidNpiMapping");
  
  //   if (!taxIDMappingRaw) {
  //     return false;
  //   }
  
  //   const taxIDMapping = JSON.parse(taxIDMappingRaw);
  
  //   if (!Array.isArray(taxIDMapping)) {
  //     return false;
  //   }
  
  //   return taxIDMapping.some(item => item.TaxID == taxId);
  // };

  validateTaxId = (taxId) => {
    if (this.checkUserRole("Group User") || this.checkUserRole("IPA User")) {
      let taxIDMapping = JSON.parse(sessionStorage.getItem("taxidNpiMapping"))
      let selectedItem = taxIDMapping.filter(item => item.TaxID == taxId)[0]
      if (!selectedItem) {
        return false
      } else return true

    } else return true
  }
  

  closeDrawer = () => {
    this.setState({
      showDrawer: false,
      type: "new",
      filteredNpis: [],
      searchNpis: false,
      searchInput: ""
    });
   
    
  };

  render() {
    const allowedPlans = ["csh", "ultimate", "solis", "sonder", "PodAmerica"];
    const planName = sessionStorage.getItem("planName")?.toLowerCase();
    const showDsnpQuestion =
    this.state.SelectValue === "Plan Admin" &&
    allowedPlans.includes(planName);

  const isDsnpValid =
    !showDsnpQuestion ||
    this.state.IsDSNP === 0 ||
    this.state.IsDSNP === 1;

    var today = new Date();
    let Rolecount = 0;
    const { Option } = Select;
    const { Search } = Input;
    const { getFieldDecorator } = this.props.form;
    const { ProviderNPIs, TaxID } = this.state;
    const formItemLayout = {
      labelCol: {
        xs: { span: 5 },
        sm: { span: 10 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 },
      },
    };
    return (
      <div>
<div>
          <Drawer
            style={{ borderRadius: "28px 28px 0px 0px" }}
            className="custom-drawer"
            placement={this.state.placement}   // "bottom" or "top"
            closable={false}
            open={this.state.showDrawer}
            key={this.state.placement}
            height="90%"
            width="100%"
          >
          <div className="px-4 mb-2 pb-3">
            {this.state.NPIstate === "TaxId" ? (
              <Col style={{ marginTop: "20px" }}>
                <Form>
                  <Form.Item>
                    {getFieldDecorator("name", {
                      initialValue: this.state.selTaxId,
                      rules: [
                        {
                          required: true,
                          message: "   ",
                        },
                        { min: 9, message: 'Tax Id must have 9 digits.' },
                        { max: 9, message: 'Tax Id must have 9 digits only.' },
                        { validator: this.anyValidation },
                        {
                          pattern: new RegExp("^[0-9]*$"),
                          message: "Enter Numbers Only!",
                        }
                      ],

                    })(
                      <Search id="tax_button"
                        placeholder={
                          this.state.NPIstate === "TaxId"
                            ? "Enter Tax ID to search NPIs"
                            : "Enter and select NPI to add"
                        }

                        enterButton="Search"
                        size="large"
                        onSearch={this.onSearch}
                        style={{ height: "41px" }}
                      // maxLength="9"
                      // minLength="9"
                      />)}
                  </Form.Item>
                </Form>
              </Col>
            ) : (
              <Col style={{ marginTop: "20px" }} className="mb-2">
                  <AutoComplete
                    size="large"
                    style={{ width: "100%" }}
                    options={this.state.filteredNpis.map(item => ({ value: item }))}
                    onSelect={this.onSelect}
                    onBlur={this.onBlurEvent}
                    filterOption={(inputValue, option) =>
                      option.value.toUpperCase().includes(inputValue.trim().toUpperCase())
                    }
                    value={this.state.searchInput}
                    onChange={this.onChange}
                  >
                    <Input.Search
                      style={{ height: "41px" }}
                      placeholder={
                        this.state.NPIstate === "TaxId"
                          ? "Enter Tax ID to search NPIs"
                          : "Enter and search NPI to add"
                      }
                      enterButton="Search"
                      size="large"
                      onSearch={this.handleSearch}
                      ref={input => { this.searchBar = input; }}
                    />
                  </AutoComplete>

                {this.state.searchNpis && this.state.filteredNpis.length === 0 && this.state.searchInput.trim() &&
                  <div style={{ color: "red" }}>
                    No record found!
                  </div>
                }

                {this.state.searchInput.trim() === "" && this.state.searchNpis &&
                  <div style={{ color: "red" }}>
                    Enter a valid NPI or Name to search!
                  </div>}
              </Col>
            )}
          </div>
          {/* Calling list Tax Npi component */}
          {this.state.NPIstate === "TaxId" &&
            <div className="pl-4 pt-2 mt-4">
              {(this.state.npisList.length > 0 && this.state.showList) || this.state.isLoading ?
                <ListTaxNpi
                  selTaxNPIs={this.state.selTaxNPIs}
                  totalTaxNPIs={this.state.totalTaxNPIs}
                  removeTaxNPI={this.removeTaxNPI}
                  addTaxNPI={this.addTaxNPI}
                  isLoading={this.state.isLoading}
                  npisList={this.state.npisList}
                  setNpisList={this.setNpisList}
                /> :
                <div>
                  {this.state.npisList.length === 0 && this.state.selTaxId &&
                    <div style={{ textAlign: "center" }}>
                      <img src={InvalidTax}></img>
                      <div className="imgDesc mt-2">
                        {this.validateTaxId(this.state.selTaxId) ? "Please Check the Tax ID and Search Again" :
                          "You can only access yours Group Tax ID"}
                      </div>
                    </div>}
                  {this.state.npisList.length === 0 && !this.state.selTaxId &&
                    <div style={{ textAlign: "center" }}>
                      <img src={BlankNpi}></img>
                      <div className="imgDesc mt-2">
                        Please Enter & search Tax ID to get list of Associated NPIs
                      </div>
                    </div>}
                </div>}
           </div>}

            {this.state.NPIstate != "TaxId" && <div className="pl-4 pt-2 pr-4 pb-3">
            {this.state.dataLoader && <Row
              style={{
                textAlign: "center",
                marginTop: "30vh"
              }}>
              <Spin size="large" />
             </Row>}
            {!this.state.dataLoader && <div>
              {this.state.SelectedNPIList.length > 0 ? (
                <AddNpiGroup
                  NPIListData={this.state.SelectedNPIList}
                  DeleteNPI={this.DeleteNPI}
                  closeDrawer={this.closeDrawer}
                />
              ) : (
                <div style={{ textAlign: "center" }}>
                  <img className="mt-3" src={BlankNpi}></img>
                  <div className="imgDesc mt-2">
                    Please Enter NPI to see the availability
                  </div>
                </div>
              )}
            </div>}
          </div>
          }

          {/* Done and cancle Button for TaxId and NPI */}

          <Row className="m-4 pb-3" justify="space-between" type="flex">
            <Col>
              {this.state.type === "edit" &&
                <button
                  className="delete-alluser danger pl-4 pr-4"
                  onClick={this.showModal}
                >
                  Delete Combination
                </button>
              }
            </Col>
            <Col>
              <button
                className="cancle-button pl-4 pr-4"
                onClick={this.closeDrawer}
              >
                Cancel
              </button>
              {(this.state.selTaxNPIs.length > 0 ||
                this.state.SelectedNPIList.length > 0) &&
                (
                  // <Col span={12} pull={4}>
                  <button onClick={this.submitHandler} className="ml-3 butto-alluser pl-4 pr-4">{this.state.type === "edit" ? "Update" : "Done"}</button>
                  // </Col>
                )}
            </Col>
            {/* <Col span={11} pull={10}>
              <button
                className="cancle-button pl-4 pr-4"
                onClick={this.closeDrawer}
              >
                Cancel
              </button>
            </Col> */}

          </Row>
        </Drawer>
        </div>

        <div class="square-blue-profile">
          <Row
            className="ml-4"
            type="flex"
            justify-content="space-start"
            align="middle"
            style={{ padding: "10px" }}
          >
            <Col>
              <div
                style={{
                  color: "white",
                  fontSize: "18px",
                  fontWeight: "bold",
                }}
              >
                Add User
              </div>
            </Col>
            <Col push={18} className="ml-4"></Col>
          </Row>
        </div>
        <Form
          {...formItemLayout}
        // onSubmit={this.handleSubmit}
        >
          <div className="flex-container">
            {/* Personal Information */}
            <div className="flex-child">
              <div className="square-white-adduser-personalInformation ml-4 mb-5" style={{ minHeight: '286px' }}>
                <div className="PersonalInformation">
                  Enter Personal Information
                </div>
                <br />
                <Row>
                  <Col span={6} push={1}>
                    <div
                      className="form-text-decorator ml-1 mt-2"
                      style={{ fontWeight: "600", fontSize: "12px" }}
                    >
                      First Name
                      <span style={{ color: "red" }}>*</span>
                    </div>
                    {/* < InputBox bordered={true}  style={{width:"77%"}} required={true} rules={[
                          {
                            required: true,
                            message: "   ",
                          },
                          {
                            pattern: new RegExp(/^[ A-Za-z0-9!#$%&'*+-/=?^_`{|]*$/),
                            message: (
                              <span style={{ fontSize: "12px" }}>
                                No special characters
                                <br />
                              </span>
                            ),
                          },
                          {
                            max: 64,

                            message: (
                              <span style={{ fontSize: "12px" }}>
                                Can't exceed 64 characters
                                <br />
                              </span>
                            ),
                          },
                        ]}  maxLength={"65"}    size={"lg"}  name={'FirstName 254'} allowClear={false} placeholder={'Enter'} /> */}
                    <Form.Item name="FirstName">
                      {getFieldDecorator("FirstName", {
                        rules: [
                          {
                            required: true,
                            message: "   ",
                          },
                          {
                            pattern: new RegExp(/^[ A-Za-z0-9!#$%&'*+-/=?^_`{|]*$/),
                            message: (
                              <span style={{ fontSize: "12px" }}>
                                No special characters
                                <br />
                              </span>
                            ),
                          },
                          {
                            max: 64,

                            message: (
                              <span style={{ fontSize: "12px" }}>
                                Can't exceed 64 characters
                                <br />
                              </span>
                            ),
                          },
                        ],
                      })(
                        <Input size="lg" placeholder="Enter" maxLength="65" />
                      )}
                    </Form.Item>
                  </Col>

                  <Col span={6} push={1} hidden>
                    <div
                      className="form-text-decorator ml-1 mt-2"
                      style={{ fontWeight: "600", fontSize: "12px" }}
                    >
                      Id
                      <span style={{ color: "red" }}>*</span>
                    </div>
                    <Form.Item>
                      {getFieldDecorator("Id", {
                        initialValue: sessionStorage.getItem("UserID"),
                        rules: [
                          {
                            required: false,
                            message: "   ",
                          },
                        ],
                      })(
                        <Input size="lg" placeholder="Enter" maxLength="24" />
                      )}
                    </Form.Item>
                  </Col>
                  <Col span={6} push={1} hidden>
                    <div
                      className="form-text-decorator ml-1 mt-2"
                      style={{ fontWeight: "600", fontSize: "12px" }}
                    >
                      Tanent ID
                    </div>
                    <Form.Item>
                      {getFieldDecorator("TenantID", {
                        initialValue: "",
                        rules: [
                          {
                            required: false,
                            message: "   ",
                          },
                        ],
                      })(
                        <Input size="lg" placeholder="Enter" maxLength="24" />
                      )}
                    </Form.Item>
                  </Col>
                  <Col span={6} push={1} hidden>
                    <div
                      className="form-text-decorator ml-1 mt-2"
                      style={{ fontWeight: "600", fontSize: "12px" }}
                    >
                      Tanent ID
                    </div>
                    <Form.Item>
                      {getFieldDecorator("URL", {
                        initialValue: sessionStorage.getItem("url"),
                        rules: [
                          {
                            required: false,
                            message: "   ",
                          },
                        ],
                      })(
                        <Input size="lg" placeholder="Enter" maxLength="24" />
                      )}
                    </Form.Item>
                  </Col>
                  <Col span={6} push={1}>
                    <div
                      className="form-text-decorator ml-1 mt-2"
                      style={{ fontWeight: "600", fontSize: "12px" }}
                    >
                      Middle Name
                    </div>
                    <Form.Item>
                      {getFieldDecorator("MiddleName", {
                        initialValue: "",
                        rules: [
                          {
                            required: false,
                            message: "   ",
                          },
                          {
                            pattern: new RegExp(/^[ A-Za-z0-9!#$%&'*+-/=?^_`{|]*$/),
                            message: (
                              <span style={{ fontSize: "12px" }}>
                                No special characters
                                <br />
                              </span>
                            ),
                          },
                          {
                            max: 64,

                            message: (
                              <span style={{ fontSize: "12px" }}>
                                Can't exceed 64 characters
                                <br />
                              </span>
                            ),
                          },
                        ],
                      })(
                        <Input size="lg" placeholder="Enter" maxLength="65" />
                      )}
                    </Form.Item>
                  </Col>
                  <Col span={6} push={1}>
                    <div
                      className="form-text-decorator ml-1 mt-2"
                      style={{ fontWeight: "600", fontSize: "12px" }}
                    >
                      Last Name
                      <span style={{ color: "red" }}>*</span>
                    </div>
                    <Form.Item>
                      {getFieldDecorator("LastName", {
                        initialValue: "",
                        rules: [
                          {
                            required: true,
                            message: "   ",
                          },
                          {
                            max: 64,

                            message: (
                              <span style={{ fontSize: "12px" }}>
                                Can't exceed 64 characters
                                <br />
                              </span>
                            ),
                          },
                          {
                            pattern: new RegExp(/^[ A-Za-z0-9!#$%&'*+-/=?^_`{|]*$/),
                            message: (
                              <span style={{ fontSize: "12px" }}>
                                No special characters
                                <br />
                              </span>
                            ),
                          },

                        ],
                      })(
                        <Input size="lg" placeholder="Enter" maxLength="65" />
                      )}
                    </Form.Item>
                  </Col>
                  <Col span={6} push={1} hidden>
                    <div
                      className="form-text-decorator ml-1 mt-2"
                      style={{ fontWeight: "600", fontSize: "12px" }}
                    >
                      Name
                      <span style={{ color: "red" }}>*</span>
                    </div>
                    <Form.Item>
                      {getFieldDecorator("Name", {
                        initialValue: "",
                        rules: [
                          {
                            required: false,
                            message: "   ",
                          },
                        ],
                      })(
                        <Input size="lg" placeholder="Enter" maxLength="24" />
                      )}
                    </Form.Item>
                  </Col>
                  <Col span={6} push={1} hidden>
                    <div
                      className="form-text-decorator ml-1 mt-2"
                      style={{ fontWeight: "600", fontSize: "12px" }}
                    >
                      Tax
                      <span style={{ color: "red" }}>*</span>
                    </div>
                    <Form.Item>
                      {getFieldDecorator("Tax", {
                        initialValue: "",
                        rules: [
                          {
                            required: false,
                            message: "   ",
                          },
                        ],
                      })(
                        <Input size="lg" placeholder="Enter" maxLength="24" />
                      )}
                    </Form.Item>
                  </Col>

                  <Col span={6} push={1} hidden>
                    <div
                      className="form-text-decorator ml-1 mt-2"
                      style={{ fontWeight: "600", fontSize: "12px" }}
                    >
                      NPI
                      <span style={{ color: "red" }}>*</span>
                    </div>
                    <Form.Item>
                      {getFieldDecorator("NPI", {
                        initialValue: "",
                        rules: [
                          {
                            required: false,
                            message: "   ",
                          },
                        ],
                      })(
                        <Input size="lg" placeholder="Enter" maxLength="24" />
                      )}
                    </Form.Item>
                  </Col>

                  <Col span={6} push={1} hidden>
                    <div
                      className="form-text-decorator ml-1 mt-2"
                      style={{ fontWeight: "600", fontSize: "12px" }}
                    >
                      IsAdmin
                    </div>
                    <Form.Item>
                      {getFieldDecorator("IsAdmin", {
                        initialValue: sessionStorage.getItem("AdminRole"),
                        rules: [
                          {
                            required: false,
                            message: "   ",
                          },
                        ],
                      })(
                        <Input size="lg" placeholder="Enter" maxLength="24" />
                      )}
                    </Form.Item>
                  </Col>

                  <Col span={6} push={1} style={{ marginTop: "5px" }}>
                    <div
                      className="form-text-decorator ml-1 mt-2"
                      style={{ fontWeight: "600", fontSize: "12px" }}
                    >
                      Gender
                    </div>
                    <Form.Item>
                      {getFieldDecorator("Gender", {
                        initialValue: "",
                        rules: [
                          {
                            required: false,
                            message: "   ",
                          },
                        ],
                      })(
                        <Select placeholder="Select" size="lg">
                          <Option value="Male">Male</Option>
                          <Option value="Female">Female</Option>
                        </Select>
                      )}
                    </Form.Item>
                  </Col>
                </Row>
                <br />
                <br />
                <Row></Row>
                <br />
              </div>
            </div>
            {/* Contact Information */}
            <div className="flex-child">
              <div className="square-white-adduser-EnterContactInformation mr-5 mb-5">
                <div className="ContactInformation ">
                  Enter Contact information
                </div>
                <br />
                <Row>
                  <Col span={12} push={1}>
                    <div
                      className="form-text-decorator ml-1 mt-2"
                      style={{ fontWeight: "600", fontSize: "12px" }}
                    >
                      Contact No.
                    </div>
                    <Form.Item>
                      {getFieldDecorator("PhoneNumber", {
                        rules: [
                          {
                            required: false,
                            message: "   ",
                          },
                          {
                            pattern: new RegExp("^[0-9]*$"),
                            message: "Enter Numbers Only!",
                          },
                        ],
                      })(
                        <Input
                          size="lg"
                          placeholder="Enter"
                          maxLength="24"
                          style={{ width: "130px" }}
                        />
                      )}
                    </Form.Item>
                  </Col>
                  <Col span={12} push={1}>
                    <div
                      className="form-text-decorator ml-1 mt-2"
                      style={{
                        fontWeight: "600",
                        fontSize: "12px",
                      }}
                    >
                      Fax No.
                    </div>
                    <Form.Item>
                      {getFieldDecorator("FaxID", {
                        rules: [
                          {
                            required: false,
                            message: "   ",
                          },
                          {
                            pattern: new RegExp("^[0-9+-]*$"),
                            message: "Enter Numbers Only!",
                          },
                        ],
                      })(
                        <Input
                          size="lg"
                          placeholder="Enter"
                          maxLength="24"
                          style={{ width: "130px" }}
                        />
                      )}
                    </Form.Item>
                  </Col>
                </Row>
                <br />
                <br />
                <Row>
                  <Col span={24} push={1} style={{ minHeight: "88px" }}>
                    <div
                      className="form-text-decorator ml-1 mt-2"
                      style={{ fontWeight: "600", fontSize: "12px" }}
                    >
                      Email ID
                      <span style={{ color: "red" }}>*</span>
                    </div>
                    <Form.Item>
                      {getFieldDecorator("EMail", {
                        initialValue: "",
                        rules: [
                          {
                            required: true,
                            message: (
                              <span style={{ fontSize: "12px" }}>
                                This field is mandatory
                                <br />
                              </span>
                            ),
                          },
                          {
                            // pattern: new RegExp(/^[A-Za-z][\w$.]+@[\w]+\.\w+$/), //oRIGINAL
                            pattern: new RegExp(/^[a-zA-Z0-9.!#$%&'*+\-/=?^_`{|]{1,64}@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,63}$/),
                            message: (
                              <span style={{ fontSize: "12px", marginRight: "5px" }}>
                                Enter a valid email
                              </span>
                            ),
                          },
                          {
                            max: 250,
                            message: (
                              <span style={{ fontSize: "12px", marginRight: "5px" }}>
                                Email ID field allows 250 characters only
                              </span>
                            ),
                          },
                        ],
                      })(
                        <Input
                          size="lg"
                          placeholder="Enter"
                          // maxLength="24"
                          style={{ width: "312px" }}
                        />
                      )}
                    </Form.Item>
                  </Col>
                </Row>
                <br />
              </div>
            </div>
          </div>
          {/*Location Information*/}
          <div className="square-white-adduser-LocationInformation ml-4 mb-5">
            <div className="LocationInformation">
              Enter Location Information
            </div>
            <br />
            <Row className="mr-5">
              <Col span={3} className="ml-4">
                <div
                  className="form-text-decorator ml-1 mt-2"
                  style={{ fontWeight: "600", fontSize: "12px" }}
                >
                  Address 01
                  {/* <span style={{ color: "red" }}>*</span> */}
                </div>
                <Form.Item>
                  {getFieldDecorator("Address", {
                    initialValue: "",
                    rules: [
                      {
                       // required: true,
                        message: "   ",
                      },
                      {
                        pattern: new RegExp("^[a-zA-Z0-9' ']*$"),
                        message: "Special characters not allowed",
                      },
                    ],
                  })(
                    <Input
                      placeholder="Select"
                      style={{ width: "160px" }}
                      size="lg"
                    />
                  )}
                </Form.Item>
              </Col>
              <Col span={3} push={1}>
                <div
                  className="form-text-decorator ml-1 mt-2"
                  style={{ fontWeight: "600", fontSize: "12px" }}
                >
                  Address 02
                </div>
                <Form.Item>
                  {getFieldDecorator("Address2", {
                    rules: [
                      {
                        required: false,
                        message: "   ",
                      },
                      {
                        pattern: new RegExp("^[a-zA-Z0-9' ']*$"),
                        message: "Special characters not allowed",
                      },
                    ],
                  })(
                    <Input
                      placeholder="Select"
                      style={{ width: "160px" }}
                      size="lg"
                    />
                  )}
                </Form.Item>
              </Col>
              <Col span={3} push={2}>
                <div
                  className="form-text-decorator ml-1 mt-2"
                  style={{ fontWeight: "600", fontSize: "12px" }}
                >
                  City
                </div>
                <Form.Item>
                  {getFieldDecorator("City", {
                    rules: [
                      {
                        required: false,
                        message: "   ",
                      },
                      {
                        pattern: new RegExp("^[a-zA-Z' ']*$"),
                        message: "Enter Alphabets Only!",
                      },
                    ],
                  })(
                    <Input
                      placeholder="Select"
                      style={{ width: "160px" }}
                      size="lg"
                    />
                  )}
                </Form.Item>
              </Col>
              <Col span={3} push={3}>
                <div
                  className="form-text-decorator ml-1 mt-2"
                  style={{ fontWeight: "600", fontSize: "12px" }}
                >
                  State
                </div>
                <Form.Item>
                  {getFieldDecorator("State", {
                    rules: [
                      {
                        required: false,
                        message: "   ",
                      },
                      {
                        pattern: new RegExp("^[a-zA-Z' ']*$"),
                        message: "Enter Alphabets Only!",
                      },
                    ],
                  })(
                    <Input
                      size="lg"
                      placeholder="Enter"
                      style={{ width: "160px" }}
                      maxLength="24"
                    />
                  )}
                </Form.Item>
              </Col>
              <Col span={3} push={4}>
                <div
                  className="form-text-decorator ml-1 mt-2"
                  style={{ fontWeight: "600", fontSize: "12px" }}
                >
                  Zipcode
                  {/* <span style={{ color: "red" }}>*</span> */}
                </div>
                <Form.Item>
                  {getFieldDecorator("ZipCode", {
                    initialValue: "",
                    rules: [
                      {
                      //  required: true,
                        message: "   ",
                      },
                      {
                        pattern: new RegExp("^[0-9]*$"),
                        message: "Enter Numbers Only!",
                      },
                    ],
                  })(
                    <Input
                      size="lg"
                      placeholder="Enter"
                      style={{ width: "160px" }}
                      maxLength="24"
                    />
                  )}
                </Form.Item>
              </Col>
              <Col span={3} push={5}>
                <div
                  className="form-text-decorator ml-1 mt-2"
                  style={{ fontWeight: "600", fontSize: "12px" }}
                >
                  Country
                </div>
                <Form.Item>
                  {getFieldDecorator("Country", {
                    rules: [
                      {
                        required: false,
                        message: "   ",
                      },
                      {
                        pattern: new RegExp("^[a-zA-Z' ']*$"),
                        message: "Enter Alphabets Only!",
                      },
                    ],
                  })(
                    <Input
                      size="lg"
                      placeholder="Enter"
                      style={{ width: "160px" }}
                      maxLength="24"
                    />
                  )}
                </Form.Item>
              </Col>
            </Row>
            <br />
            <br />
          </div>

          {/*Select Role*/}
          <div className="square-white-adduser-Role  ml-4 mb-5 px-2">
            {/* <div className="LocationInformation">Select Role</div> */}
            {/* <Row> */}
            <div className="p-2 PersonalInformation mb-4"> Assign Role</div>

            <div className="p-2">
              {this.checkUserRole("Plan Admin") && (
                <Card className="card-css pl-2 pr-2 pt-1 pb-1 mb-3">
                  <Row>
                    <Col span={20} className="question-css">
                      01. Do you want to assign User-Admin privileges to the
                      user ?<span style={{ color: "#D14A4A" }}>*</span>
                    </Col>
                    <Col span={4} style={{ textAlign: "right" }}>
                      <Radio.Group
                        onChange={(e) => this.onChange(e, "admin")}
                        value={this.state.UserType}
                      >
                        <Radio value={1} className="question-css">
                          Yes
                        </Radio>
                        <Radio value={2} className="question-css">
                          No
                        </Radio>
                      </Radio.Group>
                    </Col>
                  </Row>
                </Card>
              )}
              {/* </div> */}

              
              {/* Diplay After Selection */}
              {/* {this.state.UserType === 1 && (
                  <Card className="card-css pl-2 pr-2 pt-1 pb-1">
                    <Row justify="space-between" type="flex">
                      <Col span={10} className="question-css">
                        02. Please select one role for the user, if required{" "}
                        <span style={{color: "#D14A4A"}}>*</span>
                      </Col>
                      <Col span={14} style={{textAlign: "right"}}>
                        <Radio.Group
                          onChange={this.ChangeWithOptions}
                          value={this.state.RoleWithOptions}
                        >
                          <Radio value={"Plan Admin"} className="question-css">
                            Plan Admin
                          </Radio>
                          <Radio value={"Group User"} className="question-css">
                            Group User
                          </Radio>
                          <Radio value={"IPA User"} className="question-css">
                            IPA User
                          </Radio>
                          <Radio value={"Provider"} className="question-css">
                            Provider
                          </Radio>
                        </Radio.Group>
                      </Col>
                    </Row>
                  </Card>
                )} */}

              {
                <Card className="card-css pl-2 pr-2 pt-1 pb-1">
                  <Row>
                    <Col span={10} className="question-css">
                      {this.checkUserRole("Plan Admin") ? "02. " : "01. "}{" "}
                      Please select one role for the user.{" "}
                      <span style={{ color: "#D14A4A" }}>*</span>
                    </Col>
                    <Col span={14} style={{ textAlign: "right" }}>
                      <Radio.Group
                        onChange={this.ChangeWithOptions}
                        value={this.state.RoleWithOptions}
                      >
                        {this.checkUserRole("Plan Admin") && (
                          <Radio value={"Plan Admin"} className="question-css">
                            Plan Admin
                          </Radio>
                        )}
                        {(this.checkUserRole("Group User") ||
                          this.checkUserRole("Plan Admin") ||
                          this.checkUserRole("IPA User")) && (
                          <Radio value={"Group User"} className="question-css">
                            Group User
                          </Radio>
                        )}
                        {(this.checkUserRole("IPA User") || this.checkUserRole("Plan Admin")) &&
                          sessionStorage.getItem("planName") !== "secur" && (
                            <Radio value={"IPA User"} className="question-css">
                              IPA User
                            </Radio>
                          )}
                        {(this.checkUserRole("Provider") ||
                          this.checkUserRole("Plan Admin")) && (
                          <Radio value={"Provider"} className="question-css">
                            Provider
                          </Radio>
                        )}
                      </Radio.Group>
                    </Col>
                  </Row>
                </Card>
              }

              {/* </Row> */}
              {/* <hr></hr> */}
              {(this.state.SelectValue === "Provider" ||
                this.state.SelectValue === "Group User" ||
                this.state.SelectValue === "IPA User") && (
                <div className="p-2 group-admin-block">
                  {this.state.SelectValue === "Provider" ? (
                     <ProviderTaxid
                     List="Add"
                     key={this.state.componentKey}
                     setProviderCombinations={this.setProviderCombinations}
                     getCombinations={this.state.ProviderNPIs}
                     setDeletedProviderCombinations={this.setDeletedProviderCombinations}
                     selectrole="Provider"
                     // getCombinations={[{taxId: 'None', npis: [
                     //   {delete: false, save: false, name: 'Lana H. McKinley', npi: '1083949010'},
                     //   {delete: false, save: false, name: 'Lana H. McKinley', npi: '1083949013'}
                     // ], delete: false, save: false}]}
                   />
                  ) : this.state.SelectValue === "Group User"  ? (
                    <GroupAdmin
                    List="Add"
                      key={this.state.componentKey}
                      setCombinations={this.setCombinations}
                      getCombinations={this.state.combinations}
                      setDeletedCombinations={this.setDeletedCombinations}
                      selectrole="Group Userr"
                      // getCombinations={[{taxId: 'None', npis: [
                      //   {delete: false, save: false, name: 'Lana H. McKinley', npi: '1083949010'},
                      //   {delete: false, save: false, name: 'Lana H. McKinley', npi: '1083949013'}
                      // ], delete: false, save: false}]}
                    />
                  ) : this.state.SelectValue === "IPA User" ? (
                    <AddIPAs2
                      // key={this.state.componentKey}
                      setCombinations1={this.setCombinations1}
                      getCombinations1={this.state.combinations1}
                      setTaxIDandNPIDetailsByIPA={
                        this.setTaxIDandNPIDetailsByIPA
                      }
                      getTaxIDandNPIDetailsByIPA={
                        this.state.taxIDandNPIDetailsByIPA
                      }
                      setEditClick={this.SeteditClickForIPAs}
                      setUpdateClick={this.SetupdateClickForIPAs}
                      // setDeletedCombinations={this.setDeletedCombinations}
                    />
                  ) : (
                    ""
                  )}
                  <br />
                </div>
              )}

              {this.checkUserRole("Plan Admin") &&
                this.state.UserType &&
                this.state.RoleWithOptions != "" && sessionStorage.getItem("planName") !== "ultimate" && (
                  <Card className="card-css pl-2 pr-2 pt-1 pb-1">
                    <Row>
                      <Col span={10} className="question-css">
                        {this.checkUserRole("Plan Admin") ? "03. " : "02. "}{" "}
                        Should the user have Eligibility Only permissions ?{" "}
                        <span style={{ color: "#D14A4A" }}>*</span>
                      </Col>
                      <Col span={14} style={{ textAlign: "right" }}>
                        <Radio.Group
                          onChange={(e) => this.onChange(e, "e&b")}
                          value={this.state.EligibilityOnly}
                          // defaultChecked = {"no"}
                        >
                          <Radio value={"yes"} className="question-css">
                            Yes
                          </Radio>
                          <Radio value={"no"} className="question-css">
                            No
                          </Radio>
                        </Radio.Group>
                      </Col>
                    </Row>
                    <span
                      style={{
                        color: "orange",
                        padding: "2px",
                        fontSize: "12px",
                      }}
                    >
                      Setting this user permission as "Yes" will enable access
                      to Eligibility Check page only and <br />
                      user will be restricted from access any other information
                      on the website apart from member's eligibility.
                    </span>
                  </Card>
                )}
            </div>
            {showDsnpQuestion && (
              <Card className="card-css pl-2 pr-2 pt-1 pb-1 mb-3">
                <Row>
                  <Col span={20} className="question-css">
                    03. Should the user be able to access DSNP Member information ?
                    <span style={{ color: "#D14A4A" }}>*</span>
                  </Col>

                  <Col span={4} style={{ textAlign: "right" }}>
                    <Radio.Group
                      onChange={(e) => this.onChange(e, "isDsnp")}
                      value={this.state.IsDSNP}
                    >
                      <Radio value={1} className="question-css">
                        Yes
                      </Radio>

                      <Radio value={0} className="question-css">
                        No
                      </Radio>
                    </Radio.Group>
                  </Col>
                </Row>
              </Card>
            )}
          </div>

          <div>
            <Row type="flex" justify="end" className="mx-5 pb-3">
              <Col>
                <button
                  className="cancle-button pl-4 pr-4"
                  onClick={this.handleReset}
                >
                  Cancel
                </button>
                {this.validateUser() &&
                  !this.state.isLoading &&
                  isDsnpValid && (
                    <button
                      className="ml-3 butto-alluser pl-4 pr-4"
                      onClick={this.handleSubmit}
                    >
                      Add User
                    </button>
                  )}

                {this.state.isLoading && (
                  <span className="ml-2">
                    <Spin size="small" />
                  </span>
                )}
              </Col>
              {/* <Col>
                <Button
                  htmlType="submit"
                  className="save-button px-4"
                  onClick={this.handleReset}
                >
                  <b>Cancel</b>
                </Button>
              </Col>
              <Col className="ml-3">
                <Button htmlType="submit" className="save-button px-4 py-1 butto-alluser">
                  <b>Add User</b>
                </Button>
              </Col> */}
            </Row>
          </div>
        </Form>
      </div>
    );
  }
}
export default Form.create({ name: "AddUser" })(AddUser);
